import React from 'react';
import image from "./background.png";
import styles from "./BackgroundImage.module.scss";
import clsx from "clsx";

export const BackgroundImage = (props) => {
  const {className} = props;

  return (
    <div className={clsx(styles.container, className)}>
      <img src={image} alt="React Logo"/>
    </div>
  );
};

BackgroundImage.propTypes = {}

BackgroundImage.defaultProps = {}

export default React.memo(BackgroundImage);